import type { OnboardingCountryCode } from '../types/onboarding';

const REGION_TO_COUNTRY: Record<string, OnboardingCountryCode> = {
  US: 'US',
  CA: 'CA',
  IN: 'IN',
  GB: 'GB',
  UK: 'GB',
};

function readDeviceLocaleTag(): string {
  try {
    if (typeof Intl !== 'undefined') {
      const fromIntl = Intl.DateTimeFormat().resolvedOptions().locale;
      if (fromIntl) return fromIntl;
    }
  } catch {
    // ignore
  }

  try {
    const nav = globalThis as { navigator?: { language?: string } };
    if (nav.navigator?.language) {
      return nav.navigator.language;
    }
  } catch {
    // ignore
  }

  return 'en-US';
}

/**
 * Infer onboarding country from device locale (no GPS).
 * Sample playground amounts stay as-is — we only preselect country + currency.
 */
export function detectCountryFromLocale(): OnboardingCountryCode {
  try {
    const tag = readDeviceLocaleTag();
    const parts = tag.replace(/_/g, '-').split('-');
    // en-US → US, en-CA → CA, hi-IN → IN, en-GB → GB
    const region = (parts.length >= 2 ? parts[parts.length - 1] : '').toUpperCase();
    if (region && REGION_TO_COUNTRY[region]) {
      return REGION_TO_COUNTRY[region];
    }
  } catch {
    // fall through
  }

  return 'US';
}
